import React, { useRef } from 'react';
import { bool, node, array, oneOf, string } from 'prop-types';
import cx from 'classnames';
import FormSucceededView from '../../pages/contact/ContactFormSucceededView';

function FormWrapper({ className, submitting, succeeded, errors, children, variant, iconColor }) {
  const containerRef = useRef(null);
  const isError = !!(errors && errors.length);
  const isSucceeded = !submitting && succeeded;

  return (
    <div
      ref={containerRef}
      className={cx('forms-wrapper__container', {
        [className]: !!className,
        'forms-wrapper__container--succeed': isSucceeded,
      })}
    >
      {!isSucceeded && children}
      {isSucceeded && <FormSucceededView />}
      {isError && (
        <ul className="forms-wrapper__errors">
          {errors.map((c) => (
            <li className="forms-wrapper__error">{c}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

FormWrapper.propTypes = {
  className: string,
  submitting: bool,
  succeeded: bool,
  errors: array,
  children: node,
  iconColor: string,
  variant: oneOf(['white', 'black']),
};

FormWrapper.defaultProps = {
  variant: 'white',
};

export default FormWrapper;
